import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useAuth } from '../context/AuthContext';
import CannabisLoader from './ui/CannabisLoader';
import { registerShefaLoaderProgress } from '../utils/shefaLoaderBridge';
import './ShefaAppBoot.css';

/** Минимальное время показа полноэкранного лоадера после `ready` (секунды ~4.5). */
const MIN_VISIBLE_MS_AFTER_READY = 4500;

/**
 * Полноэкранный оверлей с анимацией роста + `setShefaLoaderProgress` из `shefaLoaderBridge`.
 * Рендерит `children` под оверлеем; пока идёт загрузка — блокирует клики (z-index 9999).
 */
export default function ShefaAppBoot({ children }) {
  const { ready } = useAuth();
  const [minDone, setMinDone] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    return registerShefaLoaderProgress((p) => setProgress((x) => Math.max(x, p)));
  }, []);

  useEffect(() => {
    if (!ready) {
      setMinDone(false);
      const i = setInterval(() => {
        setProgress((p) => (p < 85 ? Math.min(85, p + 2 + Math.random() * 6) : p));
      }, 450);
      return () => clearInterval(i);
    }
    setProgress(100);
    const t = setTimeout(() => setMinDone(true), MIN_VISIBLE_MS_AFTER_READY);
    return () => clearTimeout(t);
  }, [ready]);

  const showLoader = !ready || !minDone;

  return (
    <>
      {children}
      {showLoader
        ? createPortal(
            <div className="shefa-app-boot-overlay" role="alertdialog" aria-busy="true" aria-label="Loading">
              <CannabisLoader progress={progress} fullScreen />
            </div>,
            document.body
          )
        : null}
    </>
  );
}
